// Seeded RNG (mulberry32). Islands are built from a fixed seed so they look the same on
// every load and in screenshots; the director gets a per-session seed so bugs can be replayed.
export interface Rng {
  (): number
  range(min: number, max: number): number
  pick<T>(items: readonly T[]): T
  seed: number
}

export function rng(seed: number): Rng {
  let a = seed >>> 0
  const next = (() => {
    a = (a + 0x6d2b79f5) >>> 0
    let t = a
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }) as Rng
  next.range = (min, max) => min + next() * (max - min)
  next.pick = (items) => items[Math.floor(next() * items.length)]!
  next.seed = seed
  return next
}
